export const initTabScroll = () => {
  const container = document.querySelector('.dsm-advanced-tabs-container');
  if (!container) {
    return;
  }

  // Attach click listener to each tab after DOM is ready
  const tabs = document.querySelectorAll('.dsm-tab');
  tabs.forEach((tab) => {
    tab.addEventListener('click', () => {
      // Delay scroll so DSM finishes updating content
      setTimeout(() => {
        container.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        });
      }, 150); // adjust timing if needed
    });
  });
};
